import { render, staticRenderFns } from "./News-Events.vue?vue&type=template&id=7fcfc45f&scoped=true"
import script from "./News-Events.vue?vue&type=script&lang=js"
export * from "./News-Events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcfc45f",
  null
  
)

export default component.exports